import styled from "styled-components";
import { THEME } from "../../../styles/theme";
import { Typography } from "@mui/material";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const UnitContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
  padding: 2rem;
  border-radius: 1.5rem;
  background-color: ${THEME.palette.background.paper};
  overflow-y: auto;
  flex: 1;
`;
export const UnitImage = styled.img`
  height: 15rem;
  object-fit: cover;
  border-radius: 1rem;
  margin-bottom: 1.5rem;
  pointer-events: none;
`;
export const GraphicContainer = styled.div`
  min-height: 100px;
  max-height: 100px;
`;
export const NoRushHoursMessage = styled(Typography)`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: gray;
`;
